angular.module('mean.accounting').filter('percentageTofix', function () {
    return function (number) {
        return !!number && isFinite(number) ? number.toFixed(2) + '%' : ' ';
    };
});



// WEBPACK FOOTER //
// ./packages/custom/accounting/public/filter/percentage.js